<template>
  <div class="drama-home">
    <div class="full-width-banner">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide class="slide slide-1">
          <img src="../assets/images/banner1.jpg" alt="Technology services and smart hardware" class="banner-image" />
        </swiper-slide>
        <swiper-slide class="slide slide-2">
          <img src="../assets/images/banner2.jpg" alt="IoT and electronic products" class="banner-image" />
        </swiper-slide>
        <swiper-slide class="slide slide-3">
          <img src="../assets/images/banner3.jpg" alt="Trade agency and cross-border logistics" class="banner-image" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>

    <div class="container">
      <section class="hero panel reveal">
        <div class="hero-copy">
          <p class="tag">Technology Services &amp; Multi-Category Trade</p>
          <h1>Technology at the core — connecting R&amp;D, products and global trade</h1>
        <p class="desc">
          Built on technical services, technology development, consulting, exchange, transfer and promotion,
          combined with IoT, AI hardware, electronic products and multi-category retail trade,
          we deliver end-to-end support from solution design and product delivery to channel distribution.
        </p>
      </div>
      <div class="hero-data">
        <div class="data-card">
          <span class="number">Technology Services</span>
          <span class="label">Full-cycle development, consulting, exchange, transfer and promotion of technology</span>
        </div>
        <div class="data-card">
          <span class="number">Smart IoT</span>
          <span class="label">IoT R&amp;D and technical services, delivered together with AI hardware sales</span>
        </div>
        <div class="data-card">
          <span class="number">Global Trade</span>
          <span class="label">Import and export of goods and technology, trade agency and international freight forwarding</span>
        </div>
      </div>
    </section>

    <section class="genres reveal">
      <div class="section-head">
        <p>Our Business</p>
        <h2>A portfolio spanning technology R&amp;D and multi-category operations</h2>
      </div>
      <div class="genre-grid">
        <article class="genre-item">
          <h3>Technology &amp; Network Services</h3>
          <p>Technical services, technology development, consulting, exchange, transfer and promotion, network technology services and IT consulting.</p>
        </article>
        <article class="genre-item">
          <h3>IoT &amp; Artificial Intelligence</h3>
          <p>IoT technology R&amp;D and technical services, AI hardware sales, other electronic device manufacturing and electronics sales.</p>
        </article>
        <article class="genre-item">
          <h3>Commercial Cryptography</h3>
          <p>Development, production and sales of commercial cryptography products for information security scenarios.</p>
        </article>
        <article class="genre-item">
          <h3>Jewelry &amp; Gifts</h3>
          <p>Jewelry manufacturing and retail, arts, crafts and collectibles retail (excluding ivory and its products), gifts and flowers.</p>
        </article>
        <article class="genre-item">
          <h3>Everyday Retail</h3>
          <p>Daily necessities, apparel and accessories, outdoor products, lighting, hardware, automotive parts, computer hardware and peripherals, communication equipment.</p>
        </article>
      </div>
    </section>

    <section class="lineup panel reveal">
      <div class="section-head">
        <p>Our Capabilities</p>
        <h2>A complete chain from R&amp;D delivery to fulfillment</h2>
      </div>
      <div class="lineup-list">
        <div class="lineup-item">
          <p class="title">R&amp;D and Technical Delivery</p>
          <p class="meta">Centered on technical services and development, we provide solution consulting, technical exchange and technology transfer to support our clients' digital upgrade.</p>
        </div>
        <div class="lineup-item">
          <p class="title">Supply Chain &amp; Channels</p>
          <p class="meta">Domestic trade agency, internet sales and import/export agency working together to connect production with consumption efficiently.</p>
        </div>
        <div class="lineup-item">
          <p class="title">Compliance Assurance</p>
          <p class="meta">We operate within applicable laws and regulatory requirements; activities requiring licenses, qualifications or approvals are conducted after such approvals are obtained.</p>
        </div>
      </div>
    </section>

    <section class="cta reveal">
      <h2>Technology-driven, multi-category and well-connected</h2>
      <p>Partner with us on technology R&amp;D, product supply, channel agency and cross-border trade for steady, long-term growth.</p>
    </section>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: "HomeView",
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
};
</script>

<style scoped>
.drama-home {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 36px;
  padding-bottom: 26px;
}

.full-width-banner {
  width: 100%;
  height: 80vh;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-button-prev,
.swiper-button-next {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.swiper-button-prev::after,
.swiper-button-next::after {
  font-size: 20px;
}

.slide {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1e2129; /* placeholder */
  position: relative;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.container {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  display: grid;
  gap: 26px;
  padding: 0 24px;
}

.panel {
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 20px;
  background: rgba(7, 14, 20, 0.72);
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.3);
}

.hero {
  padding: 32px;
  display: grid;
  gap: 22px;
  grid-template-columns: 1.25fr 1fr;
}

.hero-copy {
  display: grid;
  align-content: start;
  gap: 8px;
}

.tag {
  margin: 0;
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--accent-soft);
}

h1 {
  margin: 14px 0;
  font-size: clamp(34px, 5vw, 56px);
  line-height: 1.08;
}

.desc {
  margin: 0;
  max-width: 620px;
  line-height: 1.7;
  color: rgba(236, 245, 250, 0.82);
}

.btn {
  border: 0;
  padding: 12px 18px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.btn-solid {
  color: #fff;
  background: linear-gradient(110deg, #f4436c, #ff7d9c);
}

.hero-data {
  display: grid;
  gap: 12px;
  align-content: center;
}

.data-card {
  padding: 18px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.number {
  display: block;
  font-size: 30px;
  font-weight: 800;
}

.label {
  color: rgba(236, 245, 250, 0.75);
  font-size: 13px;
}

.genres,
.lineup,
.cta {
  padding: 26px;
}

.section-head p {
  margin: 0;
  color: var(--accent-soft);
  letter-spacing: 0.1em;
  font-size: 12px;
  text-transform: uppercase;
}

.section-head h2 {
  margin: 10px 0 18px;
  font-size: clamp(24px, 3vw, 34px);
}

.genre-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.genre-item {
  padding: 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.genre-item h3 {
  margin: 0 0 8px;
  font-size: 16px;
}

.genre-item p,
.lineup-item .meta,
.cta p {
  margin: 0;
  line-height: 1.7;
  color: rgba(236, 245, 250, 0.78);
}

.lineup-list {
  display: grid;
  gap: 12px;
}

.lineup-item {
  padding: 16px;
  border-radius: 14px;
  background: linear-gradient(120deg, rgba(244, 67, 108, 0.12), rgba(255, 255, 255, 0.06));
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.lineup-item .title {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
}

.cta {
  border-radius: 20px;
  text-align: center;
  background: linear-gradient(120deg, rgba(244, 67, 108, 0.2), rgba(30, 33, 41, 0.85));
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.cta h2 {
  margin-top: 0;
}

.cta .btn {
  margin-top: 14px;
}

.reveal {
  opacity: 0;
  transform: translateY(20px);
  animation: rise 0.7s ease forwards;
}

.reveal:nth-child(2) {
  animation-delay: 0.1s;
}

.reveal:nth-child(3) {
  animation-delay: 0.2s;
}

.reveal:nth-child(4) {
  animation-delay: 0.3s;
}

@keyframes rise {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1060px) {
  .hero {
    grid-template-columns: 1fr;
  }

  .genre-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .full-width-banner {
    height: 56vh;
  }
}

@media (max-width: 900px) {
  .container {
    padding: 0 20px;
  }
}

@media (max-width: 720px) {
  .drama-home {
    gap: 24px;
  }

  .full-width-banner {
    height: 46vh;
    min-height: 260px;
  }

  .swiper-button-prev,
  .swiper-button-next {
    width: 38px;
    height: 38px;
  }

  .swiper-button-prev::after,
  .swiper-button-next::after {
    font-size: 16px;
  }

  .container {
    padding: 0 16px;
    gap: 20px;
  }

  .hero,
  .genres,
  .lineup,
  .cta {
    padding: 20px;
  }

  .hero {
    gap: 18px;
  }

  .genre-grid {
    grid-template-columns: 1fr;
  }

  .desc {
    font-size: 14px;
  }

  .number {
    font-size: 22px;
  }
}

@media (max-width: 480px) {
  .full-width-banner {
    height: 40vh;
    min-height: 220px;
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }

  h1 {
    font-size: clamp(26px, 8vw, 34px);
  }

  .section-head h2,
  .cta h2 {
    font-size: 22px;
  }

  .hero,
  .genres,
  .lineup,
  .cta {
    padding: 16px;
    border-radius: 16px;
  }

  .data-card {
    padding: 14px;
  }

  .number {
    font-size: 20px;
  }

  .label {
    font-size: 12px;
  }
}
</style>
